/* oxlint-disable react/no-unescaped-entities */

import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, HeadlineXL } from '@sorare/core/src/atoms/typography';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop';
import { laptopAndAbove } from '@sorare/core/src/style/mediaQuery';

import stakeholders from '#src/Careers/assets/stakeholders.webp';
import { ImageSection, Img } from '#src/Careers/ui.tsx';

const StakeholdersSection = styled(ImageSection)`
  @media ${laptopAndAbove} {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    aspect-ratio: 2.1/1;
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
    background-image: url(${stakeholders});
  }
`;

const TextContainer = styled(Vertical).attrs({
  gap: 3,
})`
  @media ${laptopAndAbove} {
    background: radial-gradient(
      circle,
      var(--c-nl-500),
      var(--c-nl-300),
      transparent
    );
    max-width: 60%;
    z-index: 5;
  }
`;

export const Stakeholders = () => {
  const isLaptopAndAbove = useIsLaptop();

  return (
    <>
      {!isLaptopAndAbove && (
        <Img src={stakeholders} alt="Sorare stakeholders" />
      )}
      <StakeholdersSection vAlignContent="center" blackLayer="left">
        <TextContainer>
          <HeadlineXL>Sorare stakeholders</HeadlineXL>
          <BodyM>
            Sorare is funded by a world-class team including SoftBank,
            Benchmark, Accel Partners, and Headline; star footballers Kylian
            Mbappé, Gerard Piqué, Antoine Griezmann, and Rio Ferdinand; and key
            tech investors such as Alexis Ohanian, among many others. In
            addition, the company has promotional and/or brand ambassador
            partnerships with sports icons Lionel Messi, Zinedine Zidane, and
            Serena Williams.
          </BodyM>
          {!!isLaptopAndAbove && <div />}
        </TextContainer>
      </StakeholdersSection>
    </>
  );
};
